import React, { useEffect, useState } from "react";
import "./Header.scss";
import logoDreams from "../../images/logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`headerDreams ${menuOpen ? "menuActive" : ""}`}>
        <div className="headerDreams__container">
          <a href="#inicio" className="headerDreams__logo" onClick={closeMenu}>
            <img src={logoDreams} alt="Dreams XV" />
          </a>

          <nav className="headerDreams__nav desktopOnly">
            <a href="#inicio">Inicio</a>
            <a href="#categorias">Categorías</a>
            <a href="#inspiracion">Inspiración</a>
            <a href="#como-funciona">Cómo funciona</a>
          </nav>

          <div className="headerDreams__actions desktopOnly">
            <a
              href="https://wa.me/525564426524?text=Me%20interesa%20planear%20mis%20XV%20años"
              target="_blank"
              rel="noreferrer"
              className="providerBtn"
            >
              Contáctanos
            </a>
          </div>

          <button
            className={`menuToggle mobileOnly ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
            type="button"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      <div className={`mobileMenu ${menuOpen ? "show" : ""}`}>
        <div className="mobileMenu__top">
          <button
            className="mobileMenu__close"
            onClick={closeMenu}
            aria-label="Cerrar menú"
            type="button"
          >
            <span></span>
            <span></span>
          </button>
        </div>

        <nav className="mobileMenu__nav">
          <a href="#inicio" onClick={closeMenu}>
            Inicio
          </a>
          <a href="#categorias" onClick={closeMenu}>
            Categorías
          </a>
          <a href="#inspiracion" onClick={closeMenu}>
            Inspiración
          </a>
          <a href="#como-funciona" onClick={closeMenu}>
            Cómo funciona
          </a>
          <a
            href="https://wa.me/525564426524?text=Me%20interesa%20planear%20mis%20XV%20años"
            className="providerBtn mobileProvider"
            onClick={closeMenu}
            target="_blank"
            rel="noreferrer"
          >
            Contáctanos
          </a>
        </nav>
      </div>
    </>
  );
};

export default Header;